import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../../utils/api";
import { editUserVariantEndpoint } from "../../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const editVariantAPI = createApi(editUserVariantEndpoint, "PUT");

const editVariantSlice = createSlice({
  name: "EditVariantSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(editVariantAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editVariantAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(editVariantAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default editVariantSlice.reducer;
